import React from 'react';

import useFeatureFlag from 'hooks/useFeatureFlag';
import InteractiveRow from '@lotlinx-aws/sparky-component-library/Sparky/InteractiveRow';
import useAccess from 'hooks/useAccess';
import { useNavigateKeepParams } from 'components/KeepParamsRouter/KeepParamsRouter';
import { SidebarPopoverLink } from '../SidebarPopover.defs';

export interface SidebarPopoverRowProps {
  clickHandler: () => void;
  link: SidebarPopoverLink;
  badge?: React.ReactNode;
}

/**
 * SidebarPopoverRow
 */
export default function SidebarPopoverRow({ link, clickHandler, badge }: SidebarPopoverRowProps) {
  const showLink = useFeatureFlag(link.flag);
  const { isVmbiSubscribedOnly, isLoading: isAccessLoading } = useAccess();
  const navigate = useNavigateKeepParams();
  const hideLink = (isVmbiSubscribedOnly || isAccessLoading) && link.isVmbiSubscriptionRestricted;

  const suffixIcon =
    link.suffixIcon && link.suffixIconLocation ? (
      <div
        onClick={(e) => {
          e.stopPropagation();
          navigate(link.suffixIconLocation!);
        }}
      >
        {link.suffixIcon}
      </div>
    ) : (
      link.suffixIcon || badge
    );

  if (hideLink) {
    return <></>;
  }

  if (!link.flag) {
    return (
      <InteractiveRow
        key={link.title}
        size='large'
        label={link.title}
        handleClick={() => clickHandler()}
        iconPrefix={link.icon}
        iconSuffix={badge}
        justifyFlexStart
        data-track={`nav_popover_${link.location.replace(/^\//, '').replace(/\//g, '_')}`}
        data-track-section='sidebar_popover'
        data-track-target='navigate'
        data-track-label={link.title}
      />
    );
  }

  return showLink ? (
    <InteractiveRow
      key={link.title}
      size='large'
      label={link.title}
      handleClick={() => clickHandler()}
      iconPrefix={link.icon}
      iconSuffix={suffixIcon}
      justifyFlexStart
      data-track={`nav_popover_${link.location.replace(/^\//, '').replace(/\//g, '_')}`}
      data-track-section='sidebar_popover'
      data-track-target='navigate'
      data-track-label={link.title}
    />
  ) : (
    <></>
  );
}
